import { deleteData, getData, postData, putData } from "./commonServices";
import { ADMIN_USERS } from "../serviceUrls";

// Helper to get token from localStorage
const getToken = () => localStorage.getItem("access_token");

// Users API Service
export const usersAPI = {
  // Get all users (with pagination)
  getUsers: async (page = 1, perPage = 10) => {
    const token = getToken();
    return await getData(
      `${ADMIN_USERS}?page=${page}&per_page=${perPage}`,
      token
    );
  },

  // Get single user by ID
  getUser: async (userId) => {
    const token = getToken();
    return await getData(`${ADMIN_USERS}/${userId}`, token);
  },

  // Create new user
  createUser: async (userData) => {
    const token = getToken();
    return await postData(ADMIN_USERS, userData, token);
  },

  // Update user
  updateUser: async (userId, userData) => {
    const token = getToken();
    return await putData(`${ADMIN_USERS}/${userId}`, userData, token);
  },

  // Delete user
  deleteUser: async (userId) => {
    const token = getToken();
    return await deleteData(`${ADMIN_USERS}/${userId}`, token);
  },

  // Get user statistics
  getUserStatistics: async (userId) => {
    const token = getToken();
    return await getData(`${ADMIN_USERS}/${userId}/statistics`, token);
  },

  // Get all user statistics
  getAllUserStatistics: async () => {
    const token = getToken();
    return await getData("admin/user_stats", token);
  },
};

// Additional functions following your pattern
export const getAllUsers = (token) => {
  return getData(ADMIN_USERS, token);
};

export const addNewUser = (payload, token) => {
  return postData(ADMIN_USERS, payload, token);
};

export const updateUser = (user_id, payload, token) => {
  return putData(`${ADMIN_USERS}?user_id=${user_id}`, payload, token);
};

export const deleteUser = (user_id, token) => {
  return deleteData(`${ADMIN_USERS}?user_id=${user_id}`, token);
};
